import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import WhyChooseUs from '../components/WhyChooseUs';
import HowItWorks from '../components/HowItWorks';
import About from '../components/About';
import Locations from '../components/Locations';
import CTASection from '../components/CTASection';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';
import LeadFormModal from '../components/LeadFormModal';

const LandingPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openFormModal = () => setIsModalOpen(true);
  const closeFormModal = () => setIsModalOpen(false);

  return (
    <>
      {/* Pass the open modal function to components that contain a call-to-action button */}
      <Navbar onOpenModal={openFormModal} />
      
      <main>
        <Hero onOpenModal={openFormModal} />
        <WhyChooseUs />
        <HowItWorks onOpenModal={openFormModal} />
        <About />
        <Locations onOpenModal={openFormModal} />
        <Testimonials />
        <CTASection onOpenModal={openFormModal} />
      </main>
      
      <Footer />
      
      {/* The Popup Form triggered by the buttons */}
      <LeadFormModal isOpen={isModalOpen} onClose={closeFormModal} />
    </>
  );
};

export default LandingPage;